var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-container"},[_c('img',{style:({height:_vm.height}),attrs:{"src":require(("@/assets/imgs/" + _vm.src))}}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }